<template>
  <div class="tabla-riesgos">
    <div style="font-size: 14px;">
      <br />
      <b>S</b>: Severidad,
      <b>P</b>: Probabilidad,
      <b>IR</b>: Indice de Riesgo.
      <br />
      <br />
    </div>
    <el-table
      :header-cell-style="function () { return 'background-color: rgb(7, 116, 141); color: white; padding: 0px;'}"
      :max-height="700"
      :data="risks"
      :default-sort="{ prop: 'mfl', order: 'descending' }"
      style="width: 100%;"
      :cell-class-name="pintar"
    >
      <el-table-column type="expand" width="30">
        <template
          slot-scope="props"
          v-if="!props.row.tipo || filtro_tipo_riesgo[props.row.tipo.toLowerCase()]"
        >
          <el-row :gutter="20">
            <el-col :sm="8">
              <h4>{{$t('Causas')}}</h4>
              <ol>
                <li v-for="(causa, ic) in props.row.causas" :key="ic">{{ causa.nombre }}</li>
              </ol>
            </el-col>
            <el-col :sm="8">
              <h4>{{$t('Controles Preventivos')}}</h4>
              <ol>
                <li
                  v-for="(control, ic) in getControlesPreventivos(props.row)"
                  :key="ic"
                  :class="tablaControlCritico(control)"
                >{{ control.nombre }}</li>
              </ol>
            </el-col>
            <el-col :sm="8">
              <h4>{{$t('Controles Mitigatorios')}}</h4>
              <ol>
                <li
                  v-for="(control, ic) in getControlesMitigadores(props.row)"
                  :key="ic"
                  :class="tablaControlCritico(control)"
                >{{control.nombre}}</li>
              </ol>
            </el-col>
          </el-row>
          <div v-if="props.row.medioambiental">
            <h4>{{$t('Información Medioambiental')}}</h4>
            <el-row :gutter="20">
              <el-col :sm="12">
                <h5>{{$t('Responsable')}}</h5>
                {{ props.row.medioambiente.responsable }}
                <h5>{{$t('Condición')}}</h5>
                {{ props.row.medioambiente.condicion }}
                <h5>{{$t('Aspecto Ambiental')}}</h5>
                {{ props.row.medioambiente.aspecto }}
              </el-col>
              <el-col :sm="12">
                <h5>{{ $t('Evento') }}</h5>
                {{ props.row.medioambiente.evento }}
                <h5>{{ $t('Equipo Crítico') }}</h5>
                {{ props.row.medioambiente.equipo }}
                <h5>{{ $t('Evaluación Aspecto Ambiental') }}</h5>
                <el-tag :type="getMayorImpacto(props.row).mfl >= 3 ? 'danger' : 'success'">
                  {{ getMayorImpacto(props.row).mfl >= 3
                  ? $t('Significativo')
                  : $t('No Significativo') }}
                </el-tag>
              </el-col>
            </el-row>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="nombre" label="Nombre" />
      <el-table-column align="center" label="Categoría" width="150">
        <template slot-scope="scope">{{scope.row.tipo ? MaysPrimera(scope.row.tipo) : ""}}</template>
      </el-table-column>
      <el-table-column align="center" label="Sin Controles">
        <el-table-column align="center" label="S" width="50">
          <template
            slot-scope="scope"
          >{{(scope.row.sin_controles && scope.row.sin_controles.severidad) ? scope.row.sin_controles.severidad : "---"}}</template>
        </el-table-column>
        <el-table-column align="center" label="P" width="50">
          <template
            slot-scope="scope"
          >{{(scope.row.sin_controles && scope.row.sin_controles.probabilidad) ? scope.row.sin_controles.probabilidad : "---"}}</template>
        </el-table-column>
        <el-table-column align="center" label="IR" width="50">
          <template
            slot-scope="scope"
          >{{(scope.row.sin_controles && scope.row.sin_controles.probabilidad && scope.row.sin_controles.severidad) ? (scope.row.sin_controles.probabilidad * scope.row.sin_controles.severidad) : "---"}}</template>
        </el-table-column>
      </el-table-column>
      <el-table-column align="center" label="Con Controles">
        <el-table-column align="center" label="S" width="50">
          <template
            slot-scope="scope"
          >{{(scope.row.con_controles && scope.row.con_controles.severidad) ? scope.row.con_controles.severidad : "---"}}</template>
        </el-table-column>
        <el-table-column align="center" label="P" width="50">
          <template
            slot-scope="scope"
          >{{(scope.row.con_controles && scope.row.con_controles.probabilidad) ? scope.row.con_controles.probabilidad : "---"}}</template>
        </el-table-column>
        <el-table-column align="center" label="IR" width="50">
          <template
            slot-scope="scope"
          >{{(scope.row.con_controles && scope.row.con_controles.probabilidad && scope.row.con_controles.severidad) ? (scope.row.con_controles.probabilidad * scope.row.con_controles.severidad) : "---"}}</template>
        </el-table-column>
      </el-table-column>
      <el-table-column v-if="withStatus" :label="$t('Último Estado')" align="center" width="150">
        <template slot-scope="scope">
          <div v-if="scope.row.custom && $store.getters.inventario.status != 3">
            <button
              v-if="scope.row.status == 0 && scope.row.status_step != -1"
              class="btn_show_history_risk yellow"
              @click="ShowDialogHistoryRisk(scope.row)"
            >{{ $t('En Revisión') }}</button>
            <el-tag
              v-if="scope.row.status == 0 && scope.row.status_step == -1"
              type="warning"
            >{{ $t('Necesita arreglo') }}</el-tag>

            <button
              v-if="scope.row.status == 1"
              class="btn_show_history_risk green"
              @click="ShowDialogHistoryRisk(scope.row)"
            >{{$t('Aprobado')}}</button>
            <p
              v-if="scope.row.status_by"
              class="statusUpdatedAt"
              :title="$t('Persona que revisó riesgo por última vez')"
            >
              {{scope.row.status_by}}
              <br />
              {{ getPerfil(scope.row.status_position) }}
              <br />
              {{scope.row.status_updated_at | moment("DD MMM YYYY HH:mm")}}
            </p>
            <p class="statusUpdatedAt" :title="$t('Persona que le toca revisar riesgo')">
              <i class="el-icon-d-arrow-right"></i>
              {{ nextReviewer(scope.row) }}
            </p>
          </div>
          <div v-else class="no-aplica">{{$t('No aplica')}}</div>
        </template>
      </el-table-column>
      <el-table-column v-if="withStatus" label="Comentarios" min-width="100">
        <template slot-scope="scope">
          <div v-if="scope.row.custom">
            <div
              @click="verComentarios(scope.row.status_message)"
              v-if="scope.row.status_message"
              style="height: 140px; overflow: auto; cursor: pointer;"
            >
              <p style="font-size: 12px;" v-html="scope.row.status_message"></p>
            </div>
            <span class="no-aplica" v-else>{{$t('Sin comentarios')}}</span>
          </div>
          <div v-else class="no-aplica">{{$t('No aplica')}}</div>
        </template>
      </el-table-column>
      <el-table-column
        label="PDF"
        v-if="this.$store.getters.inventario.status == 2
          || this.$store.getters.inventario.status == 3"
        align="center"
        width="200"
      >
        <template slot-scope="scope">
          <div class="text-center">
            <el-button
              class="button_img"
              size="small"
              @click="imprimirTabla(scope.row._id)"
              :loading="isLoadingPDFTabla"
            >
              <img class="img_pdf" src="@/assets/icons/pdf-file.svg" />
              <br />
              <span>{{$t('Vista tabla')}}</span>
            </el-button>
            <el-button
              class="button_img"
              size="small"
              @click="imprimirBowtie(scope.row._id)"
              :loading="isLoadingPDFBowtie"
            >
              <img class="img_pdf" src="@/assets/icons/pdf-file.svg" />
              <br />
              <span>{{$t('Vista bowtie')}}</span>
            </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog
      :before-close="closeDialogVerificarEstado"
      width="30%"
      :title="$t('REVISIÓN')"
      :visible="dialogVerificarEstado"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <el-form :model="status">
        <div>
          <el-form-item :label="$t('Estado')">
            <el-select
              v-model="status.status_step"
              :placeholder="$t('Por favor revise el riesgo')"
              size="large"
              class="with-help-box fullWidth"
            >
              <el-option :label="$t('Revisado sin comentarios')" value="true"></el-option>
              <el-option :label="$t('Revisado con comentarios')" value="false"></el-option>
            </el-select>
            <el-popover
              class="help-box"
              placement="top"
              :title="$t('Estado')"
              width="200"
              trigger="hover"
              :content="$t('Seleccione el estado de aprobación del riesgo. Si no aprueba la evaluación del riesgo, debe seleccionar \'Revisado con comentarios\'.')"
            >
              <i slot="reference" class="el-icon-question"></i>
            </el-popover>
          </el-form-item>
          <el-form-item
            label="Comentario"
            v-if="status.status_step === 'false' || status.status_step === 'requestHSE'"
          >
            <el-input class="with-help-box" type="textarea" :rows="2" v-model="status.message" />
            <el-popover
              class="help-box"
              placement="top"
              title="Comentario"
              width="200"
              trigger="hover"
              :content="$t(`Especifique el motivo del rechazo del riesgo para que
              el  \'Coordinador \' corrija el riesgo.`)"
            >
              <i slot="reference" class="el-icon-question"></i>
            </el-popover>
          </el-form-item>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialogVerificarEstado()">{{$t('Cancelar')}}</el-button>
        <el-button type="primary" @click="saveVerificarEstado()">{{$t('Guardar')}}</el-button>
      </span>
    </el-dialog>

    <el-dialog
      top="15px"
      :before-close="closeChangeRisk"
      :title="$t('Modificando Riesgo o Aspecto Ambiental')"
      width="90%"
      :visible="dialogChangeRiskVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <p>{{$t('A continuación puede modificar el riesgo según lo indicado por el revisor. Por favor, verifique bien antes de guardar.')}}</p>
      <InventarioBowtie
        :editable="true"
        :risk="this.actualRisk"
        :addCause="addCause"
        :deleteCause="deleteCause"
        :editCause="editCause"
        :addImpact="addImpact"
        :deleteImpact="deleteImpact"
        :editImpact="editImpact"
        :addPreventiveControl="addPreventiveControl"
        :deletePreventiveControl="deletePreventiveControl"
        :editPreventiveControl="editPreventiveControl"
        :addMitigationControl="addMitigationControl"
        :deleteMitigationControl="deleteMitigationControl"
        :editMitigationControl="editMitigationControl"
        :addEvaluator="addEvaluator"
        :deleteEvaluator="deleteEvaluator"
        :editEvaluator="editEvaluator"
      />

      <span slot="footer" class="dialog-footer">
        <el-button @click="closeChangeRisk()">{{$t('Cancelar')}}</el-button>
        <el-button type="primary" @click="saveRisk()">{{$t('Guardar')}}</el-button>
      </span>
    </el-dialog>

    <el-dialog :before-close="handleClose" handle width="70%" :visible="dialogHistoryRiskVisible">
      <div class="dialog_show_history_risk">
        <span class="color_orange font-title">
          <b>{{$t('Historial del Riesgo')}}</b>
        </span>
        <br />
        <b>Nombre del riesgo:</b>
        {{$t(nombreRiesgo)}}
        <br />
        <b>Último usuario en revisar:</b>
        {{ ultimoRevisor }}
        <br />
        <b>Fecha última revisión:</b>
        {{ fechaUltimaRevision | moment("DD MMM YYYY HH:mm") }}
        <br />
        <br />
        <div class="HistoryRisk_container">
          <HistoryRisk
            :ultimoRevisor="ultimoRevisor"
            :fechaUltimaRevision="fechaUltimaRevision"
            :revisores_history="revisores_history"
            :paso_actual="status_step"
          />
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          size="small"
          @click="dialogHistoryRiskVisible = false"
        >{{$t('Cerrar')}}</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="Historial de comentarios"
      :visible.sync="openDialogComentario"
      width="30%"
      :before-close="handleClose"
    >
      <div style="height: 400px; overflow: auto;">
        <p v-html="comentario"></p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="openDialogComentario = false">Cerrar</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import uuid from "uuid/v4";
import moment from "moment-timezone";
import { Loading } from "element-ui";
import { mapGetters, mapActions } from "vuex";
import { Roles } from "@/utils/generalObjects";
import { canChangeRisk, findRootArea } from "@/utils/generalFunctions";

import HistoryRisk from "@/components/HistoryRisk.vue";
import InventarioBowtie from "@/components/InventarioBowtie.vue";
import {
  probabilidades,
  nivelSeveridad,
  factorSeveridad
} from "@/lang/tableInformation.js";

export default {
  components: {
    InventarioBowtie,
    HistoryRisk
  },
  props: {
    contractPeople: {
      type: Array
    },
    contract: {
      type: Object
    },
    workflows: {
      type: Object
    },
    task: {
      type: Object,
      required: false
    },
    risks: {
      type: Array,
      required: true
    },
    withStatus: {
      type: Boolean,
      // required: true,
      default: false
    },
    filtro_tipo_riesgo: {
      type: Object,
      default: () => ({
        "Salud y Seguridad": true,
        "salud y seguridad": true,
        salud: true,
        seguridad: true,
        medioambiente: true
      })
    },
    filtro_usuario_riesgo: {
      default: false
    }
  },
  data() {
    return {
      comentario: "",
      openDialogComentario: false,
      roles: {
        contractor_coordinator: "Coordinador contratista",
        contractor_hse: "GSSO Contratista",
        administrator: "Administrador de contratos",
        coordinator: "Coordinador",
        owner: "Dueño de contrato",
        risk: "Especialista de riesgos",
        hse: "GSSO",
        health: "Salud",
        safety: "Seguridad",
        environment: "Medioambiente"
      },
      risk_copy: {},
      fechaUltimaRevision: "",
      ultimoRevisor: "",
      factorSeveridad,
      nivelSeveridad,
      probabilidades,
      Roles,
      nombreRiesgo: "",
      status_step: null,
      revisores_history: [],
      isLoadingPDFTabla: false,
      isLoadingPDFBowtie: false,
      dialogChangeRiskVisible: false,
      dialogVerificarEstado: false,
      dialogHistoryRiskVisible: false,
      actualRisk: {},
      status: {
        status: "",
        status_step: "",
        message: ""
      },
      roleCoordinator: {
        coordinator: true,
        contractor_coordinator: true
      }
    };
  },
  computed: {
    ...mapGetters({
      actualRole: "actualRole",
      usersFaena: "usersFaena"
    })
  },
  async created() {
    console.log("--.", this.risks);
    await this.getUsersFaena(this.$store.getters.role.faena_id);
  },
  methods: {
    ...mapActions(["getUsersFaena"]),
    MaysPrimera(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    verComentarios(comentario) {
      this.openDialogComentario = true;
      this.comentario = comentario;
    },
    validarTipoImpacto(risk) {
      if (
        this.getMayorImpacto(risk).impacto.categoria.toLowerCase() ===
        "salud y seguridad"
      ) {
        return "seguridad";
      }
      return this.getMayorImpacto(risk).impacto.categoria.toLowerCase();
    },
    username() {
      return `${this.$store.getters.user.nombre} ${this.$store.getters.user.apellido}`;
    },
    handleClose() {
      this.dialogHistoryRiskVisible = false;
      this.openDialogComentario = false;
    },
    pintar({ row, column, rowIndex, columnIndex }) {
      let classes = "cellClassTablaPloma ";
      if (columnIndex === 0) {
        if (row.custom === true) {
          classes += "colorCustom";
        } else if (row.impactos[0].categoria === "Seguridad" && !row.custom) {
          classes += "colorSeguridad";
        } else if (row.impactos[0].categoria === "Salud" && !row.custom) {
          classes += "colorSalud";
        } else if (
          row.impactos[0].categoria === "Salud y Seguridad" &&
          !row.custom
        ) {
          classes += "colorSaludySeguridad";
        } else if (
          row.impactos[0].categoria === "Medioambiente" &&
          !row.custom
        ) {
          classes += "colorMedioambiente";
        }
      }
      return classes;
    },
    userIsCoordinator(id) {
      const res = this.contract.revisores.contractor_coordinator.find(
        r => r === id
      );

      return res || this.contract.revisores.coordinator.find(r => r === id);
    },
    isActiveContract(contract) {
      if (contract.tipo_contrato == "Propio") return true;
      return moment(contract.fecha_fin) - new Date() >= 0;
    },
    ShowDialogHistoryRisk(risk) {
      try {
        this.ultimoRevisor = risk.status_by;
        this.fechaUltimaRevision = risk.status_updated_at;
        this.nombreRiesgo = risk.nombre;
        let revisor = {};
        this.revisores_history = [];

        const impacto = this.getMayorImpacto(risk);
        const workflow = this.workflows[risk.tipo.toLowerCase()];
        if (!workflow) {
          console.error(
            `no se encontro wf con el riesgo con el tipo ${risk.tipo}`,
            risk
          );
          this.dialogHistoryRiskVisible = true;
          return;
        } // if
        const steps = workflow.risks[impacto.mfl - 1];
        this.status_step = risk.status_step;
        let evaluador;
        steps.forEach((step, i) => {
          revisor.paso = i;
          revisor.revisores = [];
          revisor.personas =
            risk.status_history && risk.status_history[i]
              ? risk.status_history[i].map(s => s.nombre)
              : [];

          step.peopleProfile.forEach(profileName => {
            try {
              revisor.revisores.push(this.getPerfil(profileName));
              if (this.contract.revisores[profileName]) {
                for (
                  let x = 0;
                  x < this.contract.revisores[profileName].length;
                  x++
                ) {
                  evaluador = this.usersFaena.find(
                    u => u._id === this.contract.revisores[profileName][x]
                  );
                  if (evaluador) {
                    revisor.personas.push(
                      `${evaluador.nombre} ${evaluador.apellido}`
                    );
                  } // if
                }
              } else {
                switch (profileName) {
                  case "manager":
                    revisor.personas.push(
                      `${this.contract.area.gerente.nombre} ${this.contract.area.gerente.apellido}`
                    );
                    break;
                  case "general_manager":
                    // es el gerente de area raiz
                    const gmArea = findRootArea(this.contract.area);

                    gmArea
                      ? revisor.personas.push(
                          `${gmArea.gerente.nombre} ${gmArea.gerente.apellido}`
                        )
                      : console.error(
                          `No se encontro gerente general con el area: ${this.contract.area}`
                        );

                    break;
                  case "super":
                    // no todas las areas traer o encuentra [super]
                    this.contract.area[profileName] &&
                      this.contract.area[profileName].nombre &&
                      revisor.personas.push(
                        `${this.contract.area[profileName].nombre} ${this.contract.area[profileName].apellido}`
                      );
                    break;
                  default:
                    break;
                }
              }
            } catch (error) {
              console.error(error);
            } // try
          }); // forEach
          this.revisores_history.push(revisor);
          revisor = {};
        });
        this.dialogHistoryRiskVisible = true;
      } catch (e) {
        console.error(e);
      }
    }, // ShowDialogHistoryRisk

    getPerfil(profile) {
      return this.Roles[profile] || "";
    },
    nextReviewer(risk) {
      try {
        const impacto = this.getMayorImpacto(risk);
        const workflow = this.workflows[risk.tipo.toLowerCase()];
        if (!workflow) {
          console.error(
            `no se encontro wf con el riesgo con el tipo ${risk.tipo}`,
            risk
          );
        } // if
        const steps = workflow.risks[impacto.mfl - 1];
        const statusStep = parseInt(risk.status_step);
        if (!workflow) return false;
        if (
          statusStep === -1 ||
          statusStep === "-1" ||
          statusStep === undefined
        ) {
          return this.getPerfil("contractor_coordinator");
        }
        if (statusStep === steps.length) {
          return "";
        }
        const newStep = steps[statusStep];
        const reviewers = [];
        if (newStep) {
          newStep.peopleProfile.forEach(profile => {
            reviewers.push(this.getPerfil(profile));
          });
          // si todos son necesarios ', ' (and) sino ' | ' (or)
          return newStep.minToApprove > 1
            ? reviewers.join(", ")
            : reviewers.join(" | "); // solamente estético
        }
      } catch (e) {
        console.log(e);
        return "";
      }
    }, // nextReviewer
    canChangeRisk(risk) {
      return parseInt(risk.status_step) === -1 && this.$store.getters.role.admin
        ? true
        : canChangeRisk({ risk, profile: this.actualRole });
    },
    reviewedRisk(risk) {
      try {
        if (!risk.custom) return false;
        if (risk.status_step === -1) return false;
        let i = parseInt(risk.status_step);
        if (i <= 0) return false;
        //
        let reviewed = false;
        const obj = {
          user: this.$store.getters.user,
          risk: risk,
          contract: this.contract,
          actualProfile: this.actualRole,
          workflows: this.workflows
        };

        for (i; i >= 0; i--) {
          obj.risk = { ...risk };
          obj.risk.status_step = i;
          if (reviewed) break;
        } // for
        return reviewed;
      } catch (e) {
        console.error(e);
        return false;
      } // try
    }, // reviewedRisk
    async deleteRisk(risk) {
      try {
        await this.$confirm(
          this.$t(
            "Esta acción eliminará este riesgo de manera permanente. Desea continuar?"
          ),
          this.$t("Advertencia"),
          {
            confirmButtonText: this.$t("Eliminar"),
            cancelButtonText: this.$t("Cancelar"),
            type: "warning"
          }
        );
        const response = await this.$store.dispatch("deleteRiskReviewed", {
          inventory_id: this.$store.getters.inventario._id,
          task_id: this.task._id || this.task.id,
          risk
        });

        if (response.status) {
          await this.$store.dispatch("getInventory", this.contract);
          this.$alert(
            this.$t("Riesgo eliminado exitosamente."),
            this.$t("Atención"),
            {
              type: "success"
            }
          );
          let index = this.risks
            .map(function(r) {
              return r._id;
            })
            .indexOf(risk._id);
          if (index !== -1) {
            this.risks.splice(index, 1);
          }
        } else {
          this.$alert(
            this.$t(
              "Lo sentimos, surgió un error al eliminar el riesgo. Intente nuevamente."
            ),
            this.$t("Atención"),
            {
              type: "error"
            }
          );
        }
      } catch (error) {
        console.log(error);
      }
    },
    changeRisk(riesgo) {
      // Copia objeto para poder modificarlo
      this.risk_copy = JSON.parse(JSON.stringify(riesgo));
      if (!riesgo["medioambiente"]) {
        riesgo["medioambiente"] = {};
      }
      if (!riesgo["energia"]) {
        riesgo["energia"] = "";
      }
      if (!riesgo["peligro"]) {
        riesgo["peligro"] = "";
      }
      if (!riesgo["evento_no_deseado"]) {
        riesgo["evento_no_deseado"] = "";
      }
      if (!riesgo["sin_controles"]) {
        riesgo["sin_controles"] = {
          severidad: "",
          probabilidad: ""
        };
      }
      if (!riesgo["con_controles"]) {
        riesgo["con_controles"] = {
          severidad: "",
          probabilidad: ""
        };
      }
      if (!riesgo["control_adicional"]) {
        riesgo["control_adicional"] = "";
      }
      this.actualRisk = JSON.parse(JSON.stringify(riesgo));
      this.dialogChangeRiskVisible = true;
    },
    closeChangeRisk() {
      this.$confirm(
        this.$t(
          "Se perderán todos los cambios que haya realizado. ¿Está seguro de cancelar?"
        ),
        this.$t("Atención"),
        { type: "warning" }
      ).then(() => {
        this.dialogChangeRiskVisible = false;
      });
    },
    saveRisk() {
      if (JSON.stringify(this.actualRisk) === JSON.stringify(this.risk_copy)) {
        this.$confirm(
          this.$t(
            "No has realizado ningún cambio en el riesgo, estás seguro que deseas continuar?"
          ),
          this.$t("Atención"),
          { type: "warning" }
        ).then(() => {
          this.updateRisk();
        });
      } else {
        this.updateRisk();
      }
    },
    updateRisk() {
      this.$confirm(
        this.$t(
          "Estos cambios serán sujetos a revisión. ¿Está seguro de continuar?"
        ),
        this.$t("Atención"),
        { type: "warning" }
      ).then(() => {
        this.actualRisk.status = 0;
        this.actualRisk.status_step = 0;
        this.actualRisk.status_by = this.username();
        this.actualRisk.status_position = this.$store.getters.role.role;
        this.actualRisk.status_message =
          `<b>Fecha:</b> ${new Date().toLocaleString()} <br> <b>Nombre:</b> ${this.username()} <br> <b>Rol</b>: ${
            this.roles[this.$store.getters.role.role]
          } <br> <div style="margin-top: 5px; text-align: center; width: 130px; padding: 2px; color: white; background-color: green;"><b>Riesgo modificado</b></div> ${
            (this.actualRisk.status_message &&
              this.actualRisk.status_message.length) > 0
              ? "<hr style='margin-top: 15px; margin-bottom: 15px;'>"
              : ""
          }` +
          (this.actualRisk.status_message
            ? this.actualRisk.status_message
            : "");

        const loadingInstance = Loading.service({ fullscreen: true });
        this.actualRisk.status_history = [[]];
        this.$store
          .dispatch("updateRiskReviewed", {
            inventory_id: this.$store.getters.inventario._id,
            task_id: this.task.id || this.task._id,
            risk: this.actualRisk
          })
          .then(response => {
            if (response.status === true) {
              this.$store.dispatch("getInventory", this.contract);
              this.$alert(
                this.$t(
                  "Riesgo actualizado y enviado a aprobación exitosamente."
                ),
                this.$t("Atención"),
                {
                  type: "success"
                }
              );
              this.dialogChangeRiskVisible = false;
            } else {
              this.$alert(
                this.$t(
                  "Lo sentimos, surgió un error al actualizar el riesgo. Intente nuevamente."
                ),
                this.$t("Atención"),
                {
                  type: "error"
                }
              );
            }
            loadingInstance.close();
          });
      });
    },
    saveVerificarEstado() {
      this.$confirm(
        this.$t(
          "¿Está seguro de esta revisión? Un email de aviso será enviado"
        ),
        this.$t("Atención"),
        { type: "warning" }
      ).then(() => {
        const loadingInstance = Loading.service({ fullscreen: true });
        const statusHistoryVal = {};
        statusHistoryVal.nombre = this.$store.getters.user.nombre;
        statusHistoryVal.nombre += ` ${this.$store.getters.user.apellido}`;
        statusHistoryVal.fecha = this.$moment().format("LLLL");

        // Cambia status segun mfl y estado actual del paso
        let { status } = this.actualRisk;
        let statusStep = this.actualRisk.status_step;
        const { mfl } = this.getMayorImpacto(this.actualRisk);

        const workflow = this.workflows[this.actualRisk.tipo.toLowerCase()];
        // mfl = riesgo de mayor nivel
        const steps = workflow.risks[mfl - 1];
        const lastStep = steps.length;
        const actualStep = steps[statusStep];
        let statusStepApprovedByProfiles = this.actualRisk
          .status_step_approved_by_profiles
          ? this.actualRisk.status_step_approved_by_profiles
          : [];
        let statusHistory = this.actualRisk.status_history
          ? this.actualRisk.status_history
          : [[]];
        // Revision normal
        if (this.status.status_step === "true") {
          if (this.$store.getters.role.admin) {
            statusHistoryVal.perfil = "superadmin";
            statusStepApprovedByProfiles.push("superadmin");
            statusHistory[statusHistory.length - 1].push(statusHistoryVal);
            // reset cuando step está listo
            if (
              statusStepApprovedByProfiles.length >=
              parseInt(actualStep.minToApprove)
            ) {
              statusStep += 1;
              statusStepApprovedByProfiles = [];
              statusHistory.push([]);
            }
          } else {
            let profile = this.$store.getters.role.role;
            /* if (profile === 'administrator') profile = 'admin'; */
            statusStepApprovedByProfiles.push(profile);
            statusHistoryVal.perfil = profile;
            statusHistory[statusHistory.length - 1].push(statusHistoryVal);
            if (
              statusStepApprovedByProfiles.length >=
              parseInt(actualStep.minToApprove)
            ) {
              statusStep += 1;
              statusStepApprovedByProfiles = [];
              statusHistory.push([]);
            }
          }
          console.log("statusStep === lastStep", statusStep, lastStep);
          if (statusStep === lastStep) {
            status = 1;
          }
        } else {
          statusStep = -1;
          // como se rechazo el 'historial' tambien
          statusHistory = [[]];
        } // if
        const risk_id = this.actualRisk._id;
        let msj = "";
        if (this.status.message !== "") {
          msj =
            `<b>Fecha:</b> ${new Date().toLocaleString()} <br> <b>Mensaje:</b> ${
              this.status.message
            } <br> <b>Nombre:</b> ${this.username()} <br> <b>Rol</b>: ${
              this.roles[this.$store.getters.role.role]
            } ${
              this.actualRisk.status_message &&
              this.actualRisk.status_message.length > 0
                ? "<hr style='margin-top: 15px; margin-bottom: 15px;'>"
                : ""
            } ` + this.actualRisk.status_message;
        } else {
          msj = this.actualRisk.status_message;
        }
        const statusBy = `${this.$store.getters.user.nombre} ${this.$store.getters.user.apellido}`;
        const statusPosition = this.$store.getters.role.admin
          ? "superadmin"
          : this.$store.getters.role.role;
        // aqui se envia
        this.$store
          .dispatch("updateRiskStatus", {
            id: this.$store.getters.inventario._id,
            task_id: this.task.id || this.task._id,
            risk_id,
            status,
            status_step: statusStep,
            status_by: statusBy,
            status_position: statusPosition,
            status_message: msj,
            status_step_approved_by_profiles: statusStepApprovedByProfiles,
            status_history: statusHistory
          })
          .then(response => {
            if (response.status) {
              // cuando salio todo bien
              // actualiza los datos del riesgo con los datos locales
              // para evitar ir a buscar todo el inventario como lo hacia
              // antes cada vez que se editaba un riesgo
              const risk = this.risks.find(r => r._id == risk_id);
              this.$store.dispatch("InventoryEditRisk", {
                risk,
                obj: {
                  status,
                  status_step: statusStep,
                  status_by: statusBy,
                  status_position: statusPosition,
                  status_message: msj,
                  status_step_approved_by_profiles: statusStepApprovedByProfiles,
                  status_history: statusHistory
                }
              });

              // busca si hay almenos 1 riesgo sin aprobar
              const resp = this.$store.getters.inventario.tareas.some(
                t =>
                  t.riesgos &&
                  t.riesgos.some(r => r.custom == true && r.status != 1)
              );
              // si no hay entonces el inventario se aprobo
              // si se aprobo hay que setear la var de contrato que se muestra en select a aprobado
              if (resp === false) {
                this.$store.commit("EDIT_INVENTORY", { status: 2 });

                const inventoryId = this.$store.getters.inventario._id;
                this.$store.dispatch("userContractAssignInventory", {
                  inventoryId,
                  obj: { status: 2 }
                });
                this.$store
                  .dispatch(
                    "setDateInventoryApproved",
                    this.$store.getters.inventario
                  )
                  .then(async response => {
                    if (response.status === true) {
                      console.log(
                        `Fecha de aprobación actualizada para el inventario ${this.$store.getters.inventario._id}`
                      );
                    } else {
                      console.log(
                        "La fecha de aprobación no ha podido actualizarse"
                      );
                    }
                  });
              } // if

              this.$alert(response.message, this.$t("Atención"), {
                type: "success"
              });
            } else {
              this.$alert(
                this.$t(
                  "Lo sentimos, surgió un error al actualizar estado. Intente nuevamente."
                ),
                this.$t("Atención"),
                {
                  type: "error"
                }
              );
            } // if
            loadingInstance.close();
          });
        this.closeDialogVerificarEstado();
      });
    },
    closeDialogVerificarEstado() {
      this.status.status_step = "";
      this.status.message = "";
      this.actualRisk = "";
      this.dialogVerificarEstado = false;
    },
    openDialogVerificarEstado(riesgo, id) {
      this.actualRisk = riesgo;
      this.dialogVerificarEstado = true;
    },
    getControlesPreventivos(risk) {
      const controles = [];
      const controlesId = {};

      if (risk.causas) {
        risk.causas.forEach((causa, index) => {
          const id = `CA${index + 1}`;
          if (causa.controles_preventivos) {
            causa.controles_preventivos.forEach(control => {
              if (!controlesId[control.nombre]) {
                controlesId[control.nombre] = true;
                control.id_causa = id;
                controles.push(control);
              }
            });
          }
        });
      }

      return controles;
    },
    getControlesMitigadores(risk) {
      const controles = [];

      if (risk.impactos) {
        risk.impactos.forEach((impacto, index) => {
          const id = `IM${index + 1}`;

          if (impacto.controles_mitigadores) {
            impacto.controles_mitigadores.forEach(control => {
              control.id_impacto = id;
              controles.push(control);
            });
          }
        });
      }

      return controles;
    },
    getMayorImpacto(risk) {
      let mfl = 0;
      let rrr;
      let mayorImpacto;

      if (risk.impactos) {
        risk.impactos.forEach(impacto => {
          if (impacto.mfl > mfl) {
            ({ mfl } = impacto);
            rrr =
              (impacto.factor_severidad *
                10 *
                (impacto.factor_probabilidad * 10)) /
              (10 * 10);
            mayorImpacto = impacto;
          }
        });
      }

      return {
        impacto: mayorImpacto,
        mfl,
        rrr
      };
    },
    mflRange(mfl) {
      if (mfl >= 4) {
        return "danger";
      }
      if (mfl === 3) {
        return "warning";
      }
      return "gray";
    },
    sortMFL(a, b) {
      return this.getMayorImpacto(a).mfl >= this.getMayorImpacto(b).mfl;
    },
    tablaStatusClass(row) {
      try {
        let ret = "";
        if (this.withStatus) {
          ret = "";
        } else {
          const { mfl } = this.getMayorImpacto(row);
          if (mfl >= 4) {
            ret = "row-danger";
          } else if (mfl === 3) {
            ret = "row-warning";
          }
        } // if
        if (!row.row.tipo) console.error("no tipo de riesgo");

        if (
          (row.row.tipo &&
            this.filtro_tipo_riesgo[row.row.tipo.toLowerCase()] === false) ||
          (this.filtro_usuario_riesgo &&
            this.roleCoordinator[this.actualRole] &&
            !this.canChangeRisk(row.row))
        ) {
          ret += " displayNone";
        }

        return `${ret} rowClassTablaPlomaInventarioTarea`;
      } catch (e) {
        console(e);
        return "rowClassTablaPlomaInventarioTarea";
      }
    },
    addCause(causa) {
      const cause = {
        id: uuid(),
        nombre: causa
      };
      this.actualRisk.causas.push(cause);
    },
    deleteCause(causaId) {
      const causeIndex = this.actualRisk.causas.findIndex(
        cause => cause.id === causaId
      );
      Vue.delete(this.actualRisk.causas, causeIndex);
    },
    editCause(causa, causaID) {
      const causeIndex = this.actualRisk.causas.findIndex(
        cause => cause.id === causaID
      );
      Vue.set(this.actualRisk.causas, causeIndex, {
        ...this.actualRisk.causas[causeIndex],
        nombre: causa
      });
    },
    addImpact(impacto) {
      const impact = {
        id: uuid(),
        ...impacto
      };
      this.actualRisk.impactos.push(impact);
    },
    deleteImpact(impactoId) {
      const impactIndex = this.actualRisk.impactos.findIndex(
        impact => impact.id === impactoId
      );
      Vue.delete(this.actualRisk.impactos, impactIndex);
    },
    editImpact(impacto, impactoId) {
      const impactIndex = this.actualRisk.impactos.findIndex(
        impact => impact.id === impactoId
      );
      Vue.set(this.actualRisk.impactos, impactIndex, {
        ...this.actualRisk.impactos[impactIndex],
        categoria: impacto.categoria,
        descripcion: impacto.descripcion,
        factor_severidad: impacto.factor_severidad,
        factor_probabilidad: impacto.factor_probabilidad,
        nivel_severidad: impacto.nivel_severidad,
        mfl: impacto.mfl
      });
    },
    addPreventiveControl(causasId, control) {
      causasId.forEach(causaId => {
        const causeIndex = this.actualRisk.causas.findIndex(
          cause => cause.id === causaId
        );
        if (!this.actualRisk.causas[causeIndex].controles_preventivos) {
          Vue.set(this.actualRisk.causas, causeIndex, {
            ...this.actualRisk.causas[causeIndex],
            controles_preventivos: []
          });
        }
        const controlPreventivo = {
          id: uuid(),
          nombre: control
        };
        this.actualRisk.causas[causeIndex].controles_preventivos.push(
          controlPreventivo
        );
      });
    },
    deletePreventiveControl(causaId, controlId) {
      const causeIndex = this.actualRisk.causas.findIndex(
        cause => cause.id === causaId
      );
      const controlIndex = this.actualRisk.causas[
        causeIndex
      ].controles_preventivos.findIndex(control => control.id === controlId);
      Vue.delete(
        this.actualRisk.causas[causeIndex].controles_preventivos,
        controlIndex
      );
    },
    editPreventiveControl(control, controlId) {
      this.actualRisk.causas.forEach((cause, causeIndex) => {
        // Se busca si esta causa ya tiene este control asignado
        let controlIndex = -1;
        if (cause.controles_preventivos) {
          controlIndex = cause.controles_preventivos.findIndex(
            control => control.id === controlId
          );
        }

        // El control editado, tiene asociada esta causa?
        if (control.causas.includes(cause.id)) {
          // Este control ya existe en la causa?
          if (controlIndex >= 0) {
            console.log(`actualiza ${cause.nombre} en ${control.nombre}`);
            Vue.set(
              this.actualRisk.causas[causeIndex].controles_preventivos,
              controlIndex,
              {
                ...this.actualRisk.causas[causeIndex].controles_preventivos[
                  controlIndex
                ],
                nombre: control.nombre,
                critico: control.critico
              }
            );
          } else {
            // Agregar control a causa
            console.log(`agregando ${cause.nombre} en ${control.nombre}`);
            const controlPreventivo = {
              id: controlId,
              nombre: control.nombre,
              critico: control.critico
            };
            console.log(control);
            if (!this.actualRisk.causas[causeIndex].controles_preventivos) {
              Vue.set(this.actualRisk.causas, causeIndex, {
                ...this.actualRisk.causas[causeIndex],
                controles_preventivos: []
              });
            }
            this.actualRisk.causas[causeIndex].controles_preventivos.push(
              controlPreventivo
            );
          }
          // El control editado no tiene esta causa asociada actualmente
        } else {
          // Este control ya existe en la causa?
          if (controlIndex >= 0) {
            // Entonces se borra
            console.log(`borrando ${cause.nombre} de ${control.nombre}`);
            Vue.delete(
              this.actualRisk.causas[causeIndex].controles_preventivos,
              controlIndex
            );
          }
        }
      });
    },
    addMitigationControl(impactoId, control) {
      const impactIndex = this.actualRisk.impactos.findIndex(
        impact => impact.id === impactoId
      );
      if (!this.actualRisk.impactos[impactIndex].controles_mitigadores) {
        Vue.set(this.actualRisk.impactos, impactIndex, {
          ...this.actualRisk.impactos[impactIndex],
          controles_mitigadores: []
        });
      }
      const controlMitigador = {
        id: uuid(),
        nombre: control
      };
      this.actualRisk.impactos[impactIndex].controles_mitigadores.push(
        controlMitigador
      );
    },
    deleteMitigationControl(impactoId, controlId) {
      const impactIndex = this.actualRisk.impactos.findIndex(
        impact => impact.id === impactoId
      );
      const controlIndex = this.actualRisk.impactos[
        impactIndex
      ].controles_mitigadores.findIndex(control => control.id === controlId);
      Vue.delete(
        this.actualRisk.impactos[impactIndex].controles_mitigadores,
        controlIndex
      );
    },
    editMitigationControl(control, controlId) {
      this.actualRisk.impactos.forEach((impact, impactIndex) => {
        // Se busca si este impacto ya tiene este control asignado
        let controlIndex = -1;
        if (impact.controles_mitigadores) {
          controlIndex = impact.controles_mitigadores.findIndex(
            control => control.id === controlId
          );
        }

        // El control editado, tiene asociada este impacto?
        if (control.impacto === impact.id) {
          // Este control ya existe en el impacto?
          if (controlIndex >= 0) {
            console.log(`actualiza ${impact.categoria} en ${control.nombre}`);
            Vue.set(
              this.actualRisk.impactos[impactIndex].controles_mitigadores,
              controlIndex,
              {
                ...this.actualRisk.impactos[impactIndex].controles_mitigadores[
                  controlIndex
                ],
                nombre: control.nombre,
                critico: control.critico
              }
            );
          } else {
            // Agregar control a impacto
            console.log(`agregando ${impact.categoria} en ${control.nombre}`);
            const controlMitigador = {
              id: uuid(),
              nombre: control.nombre,
              critico: control.critico
            };
            this.actualRisk.impactos[impactIndex].controles_mitigadores.push(
              controlMitigador
            );
          }
          // El control editado no tiene este impacto asociada actualmente
        } else {
          // Este control ya existe en el impacto?
          if (controlIndex >= 0) {
            // Entonces se borra
            console.log(`borrando ${impact.categoria} de ${control.nombre}`);
            Vue.delete(
              this.actualRisk.impactos[impactIndex].controles_mitigadores,
              controlIndex
            );
          }
        }
      });
    },
    addEvaluator(pEvaluator) {
      if (!this.actualRisk.evaluadores) {
        this.actualRisk.evaluadores = [];
      }
      const evaluator = {
        ...pEvaluator,
        id: uuid()
      };
      this.actualRisk.evaluadores.push(evaluator);
    },
    editEvaluator(evaluator, evaluadorId) {
      const evaluatorIndex = this.actualRisk.evaluadores.findIndex(
        evaluator => evaluator.id === evaluadorId
      );
      Vue.set(this.actualRisk.evaluadores, evaluatorIndex, {
        ...this.actualRisk.evaluadores[evaluatorIndex],
        nombre: evaluator.nombre,
        rut: evaluator.rut,
        cargo: evaluator.cargo,
        empresa: evaluator.empresa
      });
    },
    deleteEvaluator(evaluadorId) {
      const evaluatorIndex = this.actualRisk.evaluadores.findIndex(
        evaluator => evaluator.id === evaluadorId
      );
      Vue.delete(this.actualRisk.evaluadores, evaluatorIndex);
    },
    tablaControlCritico(risk) {
      if (risk.critico) {
        return "control-critico";
      }
    },
    imprimirTabla(id) {
      this.isLoadingPDFTabla = true;
      this.$store.dispatch("getPDFRiesgoTablaInv", id).then(response => {
        this.isLoadingPDFTabla = false;
        // window.open(response);
      });
    },
    imprimirBowtie(id) {
      this.isLoadingPDFBowtie = true;
      this.$store.dispatch("getPDFRiesgoBowtieInv", id).then(response => {
        this.isLoadingPDFBowtie = false;
      });
    }
  }
};
</script>

<style scoped>
.tabla-riesgos {
  overflow-x: auto;
}
.el-tag.big {
  font-size: 20px;
}
.el-tag--warning {
  color: rgb(61, 45, 31);
}
.statusUpdatedAt {
  font-size: 10px;
  color: gray;
}
.tag-material {
  margin-bottom: 7px;
}
.fullWidth {
  width: 100%;
}
.nombre-riesgo {
  word-break: break-word;
}
.no-aplica {
  font-size: 12px;
  color: gray;
}
.img_pdf {
  height: 30px;
  margin-bottom: 5px;
}
.button_img {
  vertical-align: middle;
  border: none;
  padding: 0;
  background-color: transparent;
  margin: 10px;
}
.text-center {
  text-align: center;
}
.yellow {
  background-color: #e4d306;
}
.green {
  background-color: #6bc45b;
}
.btn_show_history_risk {
  background-color: #e4d306;
  padding: 3px;
  padding-left: 20px;
  padding-right: 20px;
  border: none;
  color: white;
  font-size: 15px;
  border-radius: 3px;
}
.dialog_show_history_risk {
  padding-left: 20px;
  padding-right: 20px;
  margin-top: -10px;
}
.dialog_show_history_risk span.history_tag {
  border: none;
  color: white;
  border-radius: 3px;
  background-color: #dd590096;
  float: right;
  padding-left: 10px;
  padding-right: 10px;
  font-weight: 100;
}
.color_orange {
  color: #dd5900;
}
.dialog_show_history_risk_btn_close {
  padding: 2px;
  padding-left: 10px;
  padding-right: 10px;
  color: white;
  border-radius: 3px;
  background-color: #878787;
  font-size: 12px;
  font-weight: lighter;
  display: block;
  margin: 0 auto;
}
.HistoryRisk_container {
  width: 100%;
  overflow: auto;
}
.font-title {
  font-size: 18px;
}
.buttonAction {
  margin-top: 8px;
  width: 110px;
}
.contentTooltip {
  font-family: Verdana, Geneva, Tahoma, sans-serif;
}
.full-content {
  width: 100%;
}
</style>
